module.exports = __webpack_public_path__ + "img/Slider Centro de Maquinado.ebf9c139.png";